import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { DiaryFormElement } from "../../../../../core/models/trial-diary-form/diary-form-element.model";
import { DiaryFormElementType } from "../../../../../core/constants/diary-form-element-type.enum";

@Component({
  selector: 'app-element-container',
  templateUrl: './element-container.component.html',
  styleUrl: './element-container.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ElementContainerComponent {
  @Input() element: DiaryFormElement;
  @Input() index: number = 0;
  @Input() hasEntries: boolean = false;
  @Input() allElements: DiaryFormElement[] = [];
  @Input() showCompletionWarning: boolean = false;

  @Output() moveUp = new EventEmitter();
  @Output() moveDown = new EventEmitter();
  @Output() manage = new EventEmitter();
  @Output() removeMessage = new EventEmitter<number>();
  @Output() addMessage = new EventEmitter();
  @Output() editMessage = new EventEmitter<number>();
  @Output() remove = new EventEmitter();
  @Output() visibilityEdit = new EventEmitter();

  messagesExpanded: boolean = false;

  toggleMessages(): void {
    this.messagesExpanded = !this.messagesExpanded;
  }

  get activeMessageCount(): number {
    return this.element.messages.filter(m => m.active).length;
  }

  onHandleAddMessage() {
    this.addMessage.emit();
  }

  shouldShowMessagesIcon(): boolean {
    if (this.element.elementType === DiaryFormElementType.Checkbox || this.element.elementType === DiaryFormElementType.Radio || this.element.elementType === DiaryFormElementType.Dropdown) {
      return true;
    }

    return false;
  }

  get visibilityIcon(): string {
    return this.element.defaultVisible ? 'fa-eye' : 'fa-eye-slash';
  }

  get hasVisibilityConditions(): boolean {
    return this.element.visibilityConditions?.length > 0;
  }

  get visibilityDescription(): string {
    if (!this.hasVisibilityConditions) return '';

    const parts = this.element.visibilityConditions.map(vc => {
      const sourceElement = this.allElements.find(el => el.id === vc.sourceElementId);
      const sourceOption = sourceElement?.options?.find(opt => opt.id === vc.sourceOptionId);
      const question = sourceElement?.label || 'Unknown question';
      const answer = sourceOption?.text || 'Unknown answer';
      return `'${question}' is '${answer}'`;
    });

    const operator = this.element.visibilityOperator === 1 ? ' or ' : ' and ';
    return 'Visible when ' + parts.join(operator);
  }
}
